import React, { PropTypes, Component } from 'react';
import {
  RaisedButton,
  List,
  Styles,
  ListItem,
  ListDivider,
  Avatar
} from 'material-ui';
import ScrollableContainer from 'components/ScrollableContainer';
import * as SvgIcons from 'components/Material/SvgIcons';
import { FormattedDate } from 'react-intl';
import SearchBarToolbar from 'components/SearchBarToolbar';
import * as MaterialColors from 'components/Material/Styles/Colors';

const { Spacing, Colors } = Styles;

const styles = {
  root: {
    position: 'relative',
    height: '100%'
  },
  list: {
    boxSizing: 'border-box'
  },
  searchBar: {
    boxSizing: 'border-box'
  },
  breadcrumb: {
    // backgroundColor: 'transparent',
    minWidth: 32,
    display: 'inline-block',
    margin: `10px 2px`,
    padding: `0px 4px`
  }
};

const gridSize = 140;

export default class FileSelector extends Component {
  static displayName = 'FileSelector';

  static propTypes = {
    grid: PropTypes.bool,
    hasDivider: PropTypes.bool,
    labelProperty: PropTypes.string,
    idProperty: PropTypes.string,
    items: PropTypes.array,
    onSelect: PropTypes.func,
    searchText: PropTypes.string,
    initialItemCount: PropTypes.number,
    filterChange: PropTypes.number,
    children: PropTypes.node,
    filter: PropTypes.func,
    sort: PropTypes.object,
    floatingActionButton: PropTypes.node
  };

  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func,
    media: PropTypes.string
  };

  static defaultProps = {
    searchText: null,
    labelProperty: 'name',
    idProperty: 'id',
    initialItemCount: 25,
    sort: {
      property: 'creationDate',
      direction: 'desc'
    },
    hasDivider: true,
    items: [],
    swipeEnabled: true,
    dangerouslySetInnerHTML: false
  };

  constructor() {
    super(...arguments);
    let itemCount = 25;
    const { grid } = this.props;
    if (grid) {
      itemCount =
        Math.floor(window.innerWidth / gridSize) *
        Math.ceil(window.innerHeight / gridSize);
    } else {
      itemCount = Math.ceil(window.innerHeight / 70);
    }
    this.state = {
      maxItems: itemCount,
      grid,
      deleted: {}
    };
  }

  onTouchTapItem(item) {
    if (item.type === 'dir') {
      this.props.onChangeDirectory(item.id);
    } else if (this.props.onSelect) {
      this.props.onSelect(item);
    }
  }

  onScrollToBottom() {
    this.setState({ maxItems: this.state.maxItems + 3 });
  }

  getFloatingActionButtonStyle() {
    const { muiTheme, media } = this.context;
    return Object.assign({}, styles.floatingActionButton, {
      right:
        media === 'phone'
          ? Spacing.desktopGutter
          : Spacing.desktopKeylineIncrement / 2,
      bottom:
        media === 'phopne'
          ? Spacing.desktopGutter
          : muiTheme.toolbar.height * 2 -
            muiTheme.floatingActionButton.buttonSize / 2
    });
  }

  getStyle() {
    return Object.assign({}, styles.root, {
      backgroundColor: this.context.muiTheme.primary1Color
    });
  }

  getSearchHeaderStyle() {
    const { palette } = this.context.muiTheme.rawTheme;
    return Object.assign(
      {},
      {
        backgroundColor: palette.primary1Color
      }
    );
  }

  getListStyle() {
    return Object.assign({}, styles.list);
  }

  filter(item, searchText, labelProperty) {
    if (searchText && searchText !== '') {
      return item[labelProperty].search(searchText) > -1;
    }
    return true;
  }

  searchTextChange(searchText) {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    this._timer = setTimeout(() => {
      this.setState({ searchText });
    }, 150);
  }

  toggleMode() {
    this.setState({ grid: !this.state.grid });
  }

  changeDirectory(directoryId) {
    if (this.props.onChangeDirectory) {
      this.props.onChangeDirectory(directoryId);
    }
  }

  render() {
    const children = [];
    let list;
    let detail;
    let regexp = '';
    let items = this.props.items;

    const { grid, sort, labelProperty, type } = this.props;
    const { searchText } = this.state;

    const filter = this.props.filter || this.filter;

    const size = grid ? gridSize : 40;

    if (searchText && searchText !== '') {
      regexp = new RegExp(searchText, 'i');
    }

    items = items.filter(item => {
      const created = item.created && item.created.split(' ').join('T') + 'Z';
      item.creationDate = new Date(created);
      return (
        !item.deleted &&
        (!type || item.type === 'dir' || item.type.indexOf(type) > -1) &&
        filter(item, regexp, labelProperty)
      );
    });
    if (sort && sort.property) {
      const sortProperty = sort.property;
      const sortDirection = sort.direction;

      items.sort((left, right) => {
        if (left.type === 'dir' && right.type !== 'dir') {
          return -1;
        } else if (left.type !== 'dir' && right.type === 'dir') {
          return 1;
        }
        if (typeof left[sortProperty] === 'string') {
          const leftProp = left[sortProperty].toUpperCase();
          const rightProp = right[sortProperty].toUpperCase();
          if (leftProp < rightProp) return sortDirection === 'asc' ? -1 : 1;
          if (leftProp > rightProp) return sortDirection === 'asc' ? 1 : -1;
          return 0;
        }
        const leftProp = left[sortProperty];
        const rightProp = right[sortProperty];
        if (leftProp < rightProp) return sortDirection === 'asc' ? -1 : 1;
        if (leftProp > rightProp) return sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }
    items = items.splice(0, this.state.maxItems);
    for (let i = 0; i < items.length; i++) {
      const file = items[i];
      const { id, name } = file;
      const fileType = file.type;
      let thumb;
      if (fileType === 'image') {
        // let tokens = file.url.split('.');
        // let extension = tokens.pop();
        // thumb = <Avatar src={tokens.join('.')+'-40.'+extension}/>;
        thumb = <Avatar src={file.url} style={{ borderRadius: 0 }} />;
      } else if (fileType === 'video') {
        thumb = <Avatar icon={<SvgIcons.AvMovie />} />;
      } else if (fileType === 'audio') {
        thumb = <Avatar icon={<SvgIcons.ImageAudiotrack />} />;
      } else if (fileType === 'dir') {
        thumb = (
          <Avatar
            backgroundColor={MaterialColors.Colors.lightBlue[400].material}
            size={size}
            icon={
              <SvgIcons.FileFolder
                color={MaterialColors.Colors.lightBlue[400].material}
              />
            }
            style={styles.avatar}
          />
        );
      } else {
        thumb = <Avatar icon={<SvgIcons.EditorInsertDriveFile />} />;
      }
      const createdTime =
        (file.created && file.created.split(' ').join('T')) || null;
      const date = (
        <span style={{ color: Colors.minBlack }}>
          {(createdTime && <FormattedDate value={new Date(createdTime)} />) ||
            ''}
        </span>
      );

      children.push(
        <ListItem
          leftAvatar={thumb}
          key={'i-' + id}
          onTouchTap={this.onTouchTapItem.bind(this, file)}
          primaryText={name}
          secondaryText={date}
        />
      );
      children.push(<ListDivider key={'d-' + id} />);
    }

    const crumbs = this.props.breadcrumbs.slice().reverse();
    crumbs.unshift({
      id: 0,
      name: this.context.getIntlMessage('menu.mediaLibrary')
    });

    const breadCrumbs = crumbs.map(current => {
      return (
        <RaisedButton
          style={styles.breadcrumb}
          onTouchTap={this.changeDirectory.bind(this, current.id)}
          key={current.id}
          href={`/media-library/dir/${current.id}`}
        >
          {current.name}/
        </RaisedButton>
      );
    });

    list = (
      <div style={this.getListStyle()}>
        <List>{children}</List>
      </div>
    );
    const toolbar = (
      <div style={this.getSearchHeaderStyle()}>
        <SearchBarToolbar fullWidth onChange={::this.searchTextChange} />
      </div>
    );

    return (
      <div style={this.getStyle()}>
        {breadCrumbs}
        <ScrollableContainer
          containerStyle={{
            backgroundColor: this.context.muiTheme.canvasColor
          }}
          header={toolbar}
          onScrollToBottom={this.onScrollToBottom.bind(this)}
        >
          {list}
        </ScrollableContainer>
        {detail}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/FileSelector.js